<template>
    <div class="field field--percentage" :class="fieldClasses">
        <div class="row collapse no-pad align-middle" v-if="helptext || label">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns" v-if="label">
                <label :class="labelClasses">{{ label }}</label>
            </div>
        </div>

        <div class="row">
            <div class="columns">
                <div class="formatted-input formatted-input--monetary">
                    <span
                        v-if="disabled"
                        class="formatted-input__disabled">
                    </span>
                    <cleave
                        :value="value"
                        :placeholder="placeholder"
                        :disabled="disabled"
                        :options="cleaveOptions"
                        @tabbed="tabbed"
                        @input="updateValue">
                    </cleave>
                    <span
                        class="formatted-input--monetary__prefix">
                        %
                    </span>
                </div>
            </div>
        </div>
        <div class="row" v-if="hasErrors">
            <div class="columns">
                <ul class="field__errors">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import Cleave from './misc/Cleave'
    import BaseField from './BaseField'
    import HelpText from '../HelpText'

    /**
     * Percentage Field Component
     */
    export default {
        name: 'percentage_field',
        extends: BaseField,
        components: {
            Cleave,
            HelpText
        },
        props: {
            value: {
                type: Number,
                required: false
            }
        },
        data () {
            return {
                cleaveOptions: {
                    numeral: true,
                    /**
                     * Numeral scale determined to be 20, may need review
                     *
                     * @type {Number}
                     */
                    numeralDecimalScale: 20,
                    rawValueTrimPrefix: true
                }
            }
        },
        methods: {
            updateValue (value) {
                let val = Number(value)
                this.$emit('updated', !isNaN(val) ? val : null)
            },
            tabbed () {
                this.$emit('tabbed')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/PercentageField.vue